/* eslint-disable max-len */
/* eslint-disable @nx/enforce-module-boundaries */
import { useWindowWidth } from '@prishapolicy/shared/ui';
import { lazy, Suspense } from 'react';
import { W3LazyFormProps } from './form';

const W3PFForm = lazy(() => import('./form'));
const SSRW3PurchaseFlowForm = (props: W3LazyFormProps) => {
  const { isXl } = useWindowWidth();

  if (!props.purchaseFlowForm) return null;

  return (
    <div
      className="bg-grey-100 border-grey-200 rounded-large z-10 w-full border-2 py-4 px-6 md:bg-white lg:container"
      style={{ boxShadow: '0px 4px 4px 1px rgba(0, 0, 0, 0.1)' }}
    >
      <Suspense fallback={<div style={{ minHeight: isXl ? 114 : 390 }}></div>}>
        <W3PFForm {...props} />
      </Suspense>
    </div>
  );
};

export const W3PurchaseFlowForm = SSRW3PurchaseFlowForm;
